import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import BrandTooltip from 'components/consumer/BrandTooltip';

const FabricAttributeTooltip = ({
  title = '',
  description = '',
  parentRef,
}) => (
  <BrandTooltip parentRef={parentRef}>
    <p className="text-base font-bold mb-2 mr-2 leading-5">{title}</p>
    <p className="text-xm">{description}</p>

    <div className="mt-4">
      <Link
        className="text-xs font-bold !text-white no-underline"
        to="/product-care"
        target="_blank"
      >
        View cleaning process &#8594;
      </Link>
    </div>
  </BrandTooltip>
);

FabricAttributeTooltip.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  parentRef: PropTypes.object,
};

export default FabricAttributeTooltip;
